/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import relaties from './relaties'

Vue.use(Vuex)

/* eslint-disable no-new */
const store = new Vuex.Store({
  state: {
    user : {},
    history: []
  },
  plugins: [ createPersistedState() ],
  getters: {
    isAuthenticated: (state) => {
      return state.user && state.user.username;
    },
    user: (state) => {
      return state.user;
    },
    history: (state) => {
      return state.history;
    },
  },
  actions: {
    login({commit},credentails) {
      this.$http.get("/auth", {
        auth: formData
        }).then(function(response) {
          console.log(response)
        }).catch(function(error) {
          console.log(error)
        })
      },
      addUnitToHistory({commit,state},unit) {
        console.log(unit);
        //state.history = [];
        if (state.history.filter((u) => u.unit.id == unit.unit.id).length == 0) commit('addUnit',unit);
      },
      clearHistory({state}) {
        state.history = [];
      }

  },
  mutations: {
		initialiseStore(state) {
			// Check if the ID exists
			if(localStorage.getItem('store')) {
        console.log('store exists');
				this.replaceState(
					Object.assign(state, JSON.parse(localStorage.getItem('store')))
				);
			} else {
        state.user = {}
        console.log('store does not exists');
      }
    },
    addUnit(state,unit) {
      state.history = state.history.slice(Math.max(state.history.length - 4, 0)) ;
      state.history.push(unit);
      
    },
    setUserObject(state,payload) {
      state.user = payload;
    },
	},
  modules: {
    relaties
  }
})

store.subscribe((mutation, state) => {
  console.log("state is being changed");
  // Store the state object as a JSON string
  localStorage.setItem('store', JSON.stringify(state));
})

// On (re)initialisation of the store (e.g. page reload), if the user is still
// authenticated via their httpOnly cookie, restore the SSE cache-invalidation
// connection. The EventSource JS object is lost on reload, so we must recreate it.
if (store.getters.isAuthenticated) {
  store.dispatch('relaties/refreshIfStale');
  store.dispatch('relaties/connectSse');
}

export default store
